module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/checkbox-f77e0abd8ba32614660d1f2281498d39.svg";